import CheckoutFormCard from './checkout-form-card';

export default CheckoutFormCard;
